module.exports = __webpack_public_path__ + "static/media/connectguide3.764669e8.png";